import { atomWithStorage, createJSONStorage } from 'jotai/utils';
import Cookies from 'js-cookie';

const cookieStorage = createJSONStorage<string>(() => {
  return {
    getItem: (ctx) => Cookies.get(ctx),
    setItem: (ctx, value) => Cookies.set(ctx, value),
    removeItem: (ctx) => Cookies.remove(ctx),
  };
});

export const atomWithCookieStorage = (key: string, defaultValue: string) =>
  atomWithStorage(key, Cookies.get(key) ?? defaultValue, cookieStorage);
